import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

// Dynamically import all images from 1.png to 32.png
const images = [];
for (let i = 1; i <= 32; i++) {
  images.push({
    src: require(`../../assets/images/${i}.png`),
    thumbnail: require(`../../assets/images/${i}.png`),
    alt: `Image ${i}`,
  });
}

const GallerySection = () => {
  const { t } = useTranslation();
  const [index, setIndex] = useState(-1);

  return (
    <GalleryContainer id="gallery">
      <div className="container">
        <div className="section-title">
          <h2>{t('gallery.title')}</h2>
        </div>
        
        <GalleryGrid>
          {images.map((image, idx) => (
            <GalleryItem key={idx} onClick={() => setIndex(idx)}>
              <img src={image.thumbnail} alt={image.alt} />
              <Overlay />
            </GalleryItem>
          ))}
        </GalleryGrid>
      </div>

      <Lightbox
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        slides={images.map(img => ({ src: img.src }))}
        styles={{ container: { backgroundColor: "rgba(0, 0, 0, .9)" } }}
      />
    </GalleryContainer>
  );
};

const GalleryContainer = styled.section`
  padding: 5rem 0;
  background-color: transparent;
  position: relative;
`;

const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1.5rem;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s ease;
`;

const GalleryItem = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);
  cursor: pointer;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.3s ease;
  }
  
  &:hover img {
    transform: scale(1.1);
  }
  
  &:hover ${Overlay} {
    opacity: 1;
  }
`;

export default GallerySection;